import { create } from "zustand";

const AdsyStore = create((set) => ({
  get_link_feature: {
    links: [],
    save_links: [],
  },
  user: {
    email: "",
    name: "",
  },
}));

export default AdsyStore;
